import { Point } from './types';

const rotatePoint = (point: Point, rad: number): Point => {
  const { x, y } = point;
  const rcos = Math.cos(rad);
  const rsin = Math.sin(rad);
  return { x: x * rcos - y * rsin, y: y * rcos + x * rsin };
};

export default rotatePoint;
